module.exports = __webpack_public_path__ + "static/media/user2.8752792e.jpeg";